import Vue from 'vue';
import 'src/utils/ajax';

export default function(reqOptions) {
    const { url, reqParams } = reqOptions || {};
    const reqUrl = url || '/mng/org/getOrgAndUserTreeNodes';

    const reqFun = function(options) {
        const { id, depId, index: reqIndex, count: reqCount } = options;
        let reqId = id;

        if (typeof depId !== 'undefined') {
            reqId = depId;
        }

        const reqData = {
            id: reqId,
            index: reqIndex,
            count: reqCount,
            ...reqParams
        };

        return Vue.prototype.$ajax.get(reqUrl, { params: reqData }).then(res => {
            const { list, index, count, total_node: totalNode } = res;

            return {
                data: {
                    list,
                    index,
                    count,
                    total_node: totalNode
                }
            };
        });
    };

    return reqFun;
}
